import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-psa-notifications',
  templateUrl: './psa-notifications.component.html',
  styleUrls: ['./psa-notifications.component.css']
})
export class PsaNotificationsComponent implements OnInit {
  title="Notifications";
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/main/psa-notifications/psa-notifications.component.ts